import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { LocationProvider } from "./context/LocationContext";
import { DashboardLayout } from "./components/layout/DashboardLayout";

// Pages
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Sales from "./pages/Sales";
import Products from "./pages/Products";
import Customers from "./pages/Customers";
import Payments from "./pages/Payments";
import Inventory from "./pages/Inventory";
import Accounting from "./pages/Accounting";
import Logs from "./pages/Logs";
import Settings from "./pages/Settings";
import QuickBooks from "./pages/QuickBooks";
import Odoo from "./pages/Odoo";
import UnTillInstance from "./pages/UnTillInstance";
import Locations from "./pages/Locations";
import CompareLocations from "./pages/CompareLocations";
import Destinations from "./pages/Destinations";
import SuperAdmin from "./pages/SuperAdmin";
import DryRun from "./pages/DryRun";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";

function App() {
  return (
    <AuthProvider>
      <LocationProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />

            {/* Protected Dashboard Routes */}
            <Route path="/" element={<DashboardLayout />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="sales" element={<Sales />} />
              <Route path="products" element={<Products />} />
              <Route path="customers" element={<Customers />} />
              <Route path="payments" element={<Payments />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="accounting" element={<Accounting />} />
              <Route path="quickbooks" element={<QuickBooks />} />
              <Route path="odoo" element={<Odoo />} />
              <Route path="untill" element={<UnTillInstance />} />
              <Route path="locations" element={<Locations />} />
              <Route path="compare" element={<CompareLocations />} />
              <Route path="destinations" element={<Destinations />} />
              <Route path="dry-run" element={<DryRun />} />
              <Route path="admin" element={<SuperAdmin />} />
              <Route path="logs" element={<Logs />} />
              <Route path="settings" element={<Settings />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </LocationProvider>
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: 'hsl(222 47% 7%)',
            border: '1px solid hsl(217 19% 15%)',
            color: 'hsl(210 40% 98%)'
          }
        }}
      />
    </AuthProvider>
  );
}

export default App;
